export const countFiltersApplied = (filterValues, fieldNames): number => {
  return fieldNames.filter((field) => {
    const value = filterValues[field];
    if (Array.isArray(value)) return value.length > 0;
    if (value && typeof value === "object") {
      return Object.keys(value).length > 0;
    }

    return value !== undefined && value !== null && value !== "";
  }).length;
};
